export default "__VITE_ASSET__CkL1FuHq__"